export default "__VITE_ASSET__CGza8EBs__"